import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, EventEmitter, input, Input, OnInit, Output, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { IecFinaliseBallotModalComponent } from '../iec-finalise-ballot-modal/iec-finalise-ballot-modal.component';
import { IIecBallotDetails } from '../../../shared/models/iec/iec-ballot-details';
import { Country } from '../../../../../shared/constants/srs-ballot.constants';
import { UnifiedBallotStatus } from '../../../../../shared/enums/unified-ballot-status-enum';
import { AuthService } from '../../../../../shared/services/auth.service';
import { IDonutChartItem } from '../../../../controls/donut-chart/donut-chart.component';
import { IIecBallotVote, IecVoteId, iecVoteOption } from '../../../shared/models/iec/iec-ballot-vote';


@Component({
    selector: 'app-iec-eligible-voters',
    templateUrl: './iec-eligible-voters.component.html',
    styleUrl: './iec-eligible-voters.component.scss',
    standalone: false
})

export class IecEligibleVotersComponent implements OnInit {
  @Input() iecBallotDetail: IIecBallotDetails | null = null;
  @Input() ballotVotes: IIecBallotVote[] = [];
  @Input() isJoint: boolean = false;
  @Input() BallotStatus!: UnifiedBallotStatus;

  isShowingLocations: boolean = false;
  data: IDonutChartItem[] = [];
  eligibleVotes: IIecBallotVote[] = [];

  inFavourOfCount: number = 0;
  againstCount: number = 0;
  abstainCount: number = 0;
  noneCount: number = 0;

  selectedLocation: string = 'aus-nz';
  ballotType ='iecBallot';
  isConsensusVisible: boolean = false;
  isRefresh: boolean = true;
  isUserPmOrAboveOrHoSD: boolean = false;
  isValidStatusGenerateReport: boolean = false;
  canFinaliseBallot: boolean = false;
  canGenerateReport: boolean = false;
  ballotId: string = '';

  constructor(private cdr: ChangeDetectorRef, public authService: AuthService, private _modalService: NgbModal) {}

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.ballotVotes && this.ballotVotes.length > 0) {
      this.checkConsensusVisible();
      this.filterEligibleVotes();
      this.getVoteDetails();
      this.checkNZCommittee();
      this.checkUserPermission();
      this.checkIECBallotStatus();
    }
  }

  checkUserPermission() {
    this.authService.isUserPmOrAboveOrHoSD().subscribe({
      next: (isAuthorized) => {
        this.isUserPmOrAboveOrHoSD = isAuthorized;
        this.canFinaliseBallot = isAuthorized && this.BallotStatus === UnifiedBallotStatus.closedForVoting;
        this.canGenerateReport = isAuthorized && this.BallotStatus !== UnifiedBallotStatus.scheduled;
      },
      error: (err) => {
        this.isUserPmOrAboveOrHoSD = false;
        console.error('Error checking authorization:', err);
      }
    });
  }

  checkIECBallotStatus(){
    this.isValidStatusGenerateReport = this.BallotStatus === UnifiedBallotStatus.openForVoting || this.BallotStatus === UnifiedBallotStatus.closedForVoting || this.BallotStatus === UnifiedBallotStatus.finalised;
  }

  getVoteDetails(){
    const voteCounts = this.eligibleVotes.reduce((counts: {[key: string]: number}, vote) => {
      const type = vote.iecVoteOptionName;
      if (type) {
        counts[type] = (counts[type] || 0) + 1;
      }
      return counts;
    }, {});

    // Assign counts to your specific variables
    this.inFavourOfCount = voteCounts[IecVoteId.IN_FAVOUR_OF] || 0;
    this.againstCount = voteCounts[IecVoteId.AGAINST] || 0;
    this.abstainCount = voteCounts[IecVoteId.ABSTAIN] || 0;
    this.noneCount = voteCounts[IecVoteId.NO_RESPONSE] || 0;
    if(voteCounts) {
      this.generateDonutChart(voteCounts);
    }
  }

  filterByLocation(): void {
    const filteredVotes = this.eligibleVotes.filter((vote) => {
      const voteCountry = vote.country.toLowerCase();
      if (this.selectedLocation === 'aus-nz') {
        this.isRefresh = true;
        return (
          Country.Australia.includes(voteCountry) ||
          Country.NewZealand.includes(voteCountry)
        );
      } else if (this.selectedLocation === 'aus') {
        this.isRefresh = true;
        return Country.Australia.includes(voteCountry);
      } else if (this.selectedLocation === 'nz') {
        this.isRefresh = false;
        return Country.NewZealand.includes(voteCountry);
      }

      return false;
    });



    const voteCounts = filteredVotes.reduce(
      (counts: { [key: string]: number }, vote) => {
        const type = vote.iecVoteOptionName;
        if (type) {
          counts[type] = (counts[type] || 0) + 1;
        }
        return counts;
      },
      {}
    );

    this.generateDonutChart(voteCounts);
    this.cdr.detectChanges();
  }



  generateDonutChart(voteCounts: any): void {
    const voteTypes = [
      IecVoteId.IN_FAVOUR_OF,
      IecVoteId.AGAINST,
      IecVoteId.ABSTAIN,
      IecVoteId.NO_RESPONSE,
    ];

    this.data = voteTypes.map((voteType) => ({
      label: iecVoteOption[voteType].text,
      value: voteCounts[voteType] || 0,
      color: iecVoteOption[voteType].color,
      icon: iecVoteOption[voteType].icon,
    }));
  }


  filterEligibleVotes() {
    // Filter votes based on eligibility
    this.eligibleVotes = this.ballotVotes.filter((vote) =>
      vote.isEligible
    );
  }


  chairpersonIsNotIndependentChair(committeeOrganisation: string): boolean {
    const invalidOrganisations = [
      "independent chairperson (australia)",
      "independent chairperson (nz)",
    ];
    if(!committeeOrganisation) {
      return false;
    }
    return !(
      !committeeOrganisation ||
      invalidOrganisations.includes(committeeOrganisation.trim().toLowerCase())
    );
  }

  checkNZCommittee(){
    const hasNZCommitteeVotes = this.ballotVotes.find(vote => vote.country && (Country.NewZealand.includes(vote.country.toLowerCase())));
    this.isShowingLocations = hasNZCommitteeVotes != null && this.isJoint;
  }

  checkConsensusVisible(){
    this.isConsensusVisible = (this.BallotStatus === UnifiedBallotStatus.openForVoting || this.BallotStatus === UnifiedBallotStatus.closedForVoting);
  }


  openFinaliseBallotModal() {
    const modalRef = this._modalService.open(IecFinaliseBallotModalComponent);
    modalRef.componentInstance.data = this.data;
    modalRef.componentInstance.ballotId = this.iecBallotDetail?.id || '';
  }

}

